// API Configuration
const API_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_API_BASE_URL || "https://workspace.optiven.co.ke/api",
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  RETRY_ATTEMPTS: parseInt(process.env.REACT_APP_REQUEST_RETRY_ATTEMPTS) || 3,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "development",
};

// API Endpoints
export const API_ENDPOINTS = {
  // Projects
  PROJECTS: {
    LIST: "/mib/recon/specific",
    PLOTS: (projectName) =>
      `/mib/projects/${encodeURIComponent(projectName)}/plots/paginated`,
    TRANSACTIONS: (projectName) =>
      `/mib/projects/${encodeURIComponent(projectName)}/transactions`,
  },

  // Plots
  PLOTS: {
    DETAILS: (plotId) => `/mib/plots/${encodeURIComponent(plotId)}`,
    DISCHARGE_INITIATED: "/mib/plots/discharge-initiated",
    DISCHARGE_PENDING: "/mib/plots/discharge-pending",
    DISCHARGE_UPDATE: (plotNo) =>
      `/mib/plots/${encodeURIComponent(plotNo)}/discharge`,
  },

  // Reports
  REPORTS: {
    SUMMARY: "/mib/reports/summary",
  },

  // Receipts
  RECEIPTS: {
    APPROVAL: (id) => `/mib/receipts/${id}/approval`,
    ASSIGN: (id) => `/mib/transactions/${id}/assign`,
  },

  // Sales Agreements
  AGREEMENTS: {
    LIST: (plotId) => `/sla/plots/${encodeURIComponent(plotId)}/agreements`,
    UPLOAD: (plotId) => `/sla/plots/${encodeURIComponent(plotId)}/agreements`,
    DOWNLOAD: (plotId, agreementId) =>
      `/sla/plots/${encodeURIComponent(plotId)}/agreements/${agreementId}`,
    DELETE: (plotId, agreementId) =>
      `/sla/plots/${encodeURIComponent(plotId)}/agreements/${agreementId}`,
  },
};

export default API_CONFIG;
